import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { GetPermissions, GetRoles } from '../actions/auth.actions';
import { ListTags } from '../actions/tags.actions';
import { ListForms } from '../actions/forms.actions';
import {
  selectFormsLoaded,
  selectPermissionsLoaded,
  selectRolesLoaded,
  selectTagsLoaded
} from '../selectors/catalog.selectors';
import { AppState } from '../states/app.state';

/**
 * Dispatches catalog actions only when the NgRx store cache is empty (unless force=true).
 */
@Injectable({ providedIn: 'root' })
export class CatalogFacade {
  constructor(private readonly store: Store<AppState>) {}

  ensureRoles(force = false): void {
    if (force) {
      this.store.dispatch(new GetRoles(true));
      return;
    }
    this.store
      .select(selectRolesLoaded)
      .pipe(take(1))
      .subscribe(loaded => {
        if (!loaded) {
          this.store.dispatch(new GetRoles());
        }
      });
  }

  ensurePermissions(force = false): void {
    if (force) {
      this.store.dispatch(new GetPermissions(true));
      return;
    }
    this.store
      .select(selectPermissionsLoaded)
      .pipe(take(1))
      .subscribe(loaded => {
        if (!loaded) {
          this.store.dispatch(new GetPermissions());
        }
      });
  }

  ensureTags(force = false): void {
    if (force) {
      this.store.dispatch(new ListTags(true));
      return;
    }
    this.store
      .select(selectTagsLoaded)
      .pipe(take(1))
      .subscribe(loaded => {
        if (!loaded) {
          this.store.dispatch(new ListTags());
        }
      });
  }

  ensureForms(force = false): void {
    if (force) {
      this.store.dispatch(new ListForms(true));
      return;
    }
    this.store
      .select(selectFormsLoaded)
      .pipe(take(1))
      .subscribe(loaded => {
        if (!loaded) {
          this.store.dispatch(new ListForms());
        }
      });
  }

  ensureAuthCatalog(force = false): void {
    this.ensureRoles(force);
    this.ensurePermissions(force);
  }
}

/** @deprecated Use CatalogFacade */
export { CatalogFacade as AuthCatalogFacade };
